import clsx from 'clsx';
import React from 'react';

import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import { Link } from '@/src/components/common/Elements/Link/Link';
import { generateRoutePath } from '@/src/routes';

import { INBOX_PAGE_ROUTES } from '../../../../../../../Config/inbox.routes';
import { useEmailThreadEntryViewer } from '../../../../store/emailThreadEntryViewer.store';

const PrintEmail = ({ projectId, ...otherProps }) => {
  const { selectedEmailEntry } = useEmailThreadEntryViewer();

  const href = generateRoutePath(INBOX_PAGE_ROUTES.email_enttry_print_preview.path, {
    projectId,
    emailId: selectedEmailEntry.id,
    inboxEntryId: selectedEmailEntry.inboxEntryId,
  });
  const tooltip = {
    content: 'Print',
    place: 'left',
  };

  return (
    <Link
      id={`lnk_${selectedEmailEntry.id}`}
      href={href}
      className={clsx(
        'tw-group',
        'tw-flex tw-items-center tw-justify-center',
        'tw-leading-none tw-rounded-[50px]',
        'tw-mr-0 tw-p-[3px]',
        'hover:tw-bg-cfo-blue-200'
      )}
      tooltip={tooltip}
      {...otherProps}
    >
      <Icon
        icon={ICONS.print_icon({
          mainClassName: 'tw-fill-white',
          fillClassName: 'tw-fill-cfo-black group-hover:tw-fill-cfo-blue-700',
          strokeClassName: 'tw-stroke-cfo-black group-hover:tw-stroke-cfo-blue-700',
        })}
      />
    </Link>
  );
};

export default PrintEmail;
